import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Esto garantiza que me alquilen?',
  answer: "No. Pero aumenta brutalmente tus probabilidades porque reduces dudas y fricción. Pasas de ser 'uno más' a ser el candidato que lo pone fácil."
}, {
  question: '¿Me sirve si busco en varias ciudades?',
  answer: 'Sí. El sistema es el mismo para cualquier mercado de alta demanda en España (Madrid, Barcelona, Valencia, Málaga, Palma, etc.). Solo ajustas los requisitos específicos si varían.'
}, {
  question: '¿En cuánto tiempo lo implemento?',
  answer: 'En una tarde si estás en urgencia. En 72 horas si quieres hacerlo con calma siguiendo el plan paso a paso.'
}, {
  question: '¿Sirve para alquiler de habitaciones?',
  answer: 'Los principios de Credibilidad y Claridad son idénticos. Aunque el sistema está pensado para pisos completos, te ayudará a destacar brutalmente en entrevistas de piso compartido.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#FAFAF7] py-20 px-4 sm:px-6 border-t border-gray-200" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <h2 className="text-3xl font-serif font-bold text-[#1B2A4A] text-center mb-12" data-id="element-53">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden transition-all duration-200" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-56">
                <span className="font-bold text-[#1B2A4A] text-lg pr-8" data-id="element-57">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus className="w-5 h-5 text-[#C9A84C] flex-shrink-0" data-id="element-58" /> : <Plus className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-59" />}
              </button>

              {openIndex === index && <div className="px-6 pb-6 text-gray-600 leading-relaxed animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-60">
                  {faq.answer}
                </div>}
            </div>)}
        </div>

        {/* Final CTA */}
        <div className="mt-20 text-center" data-id="element-61">
          <h3 className="text-2xl font-serif font-bold text-[#1B2A4A] mb-6" data-id="element-62">
            Deja de improvisar. Empieza a cerrar.
          </h3>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="inline-block px-10 py-5 bg-[#1B2A4A] hover:bg-[#2a3f6b] text-white font-bold text-xl rounded-lg transition-all transform hover:-translate-y-1 shadow-xl cursor-pointer" data-id="element-63">
            Descargar Carpeta 3C
          </button>
          <p className="mt-4 text-sm text-gray-500" data-id="element-64">
            Acceso inmediato · Pago seguro · Soporte por email
          </p>
        </div>

        {/* Minimal Footer */}
        <footer className="mt-24 pt-8 border-t border-gray-200 text-center text-gray-400 text-sm" data-id="element-65">
          <p data-id="element-66">
            &copy; {new Date().getFullYear()} Carpeta de Alquiler Imposible.
            Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-4 mt-4" data-id="element-67">
            <a href="#" className="hover:text-gray-600" data-id="element-68">
              Aviso Legal
            </a>
            <a href="#" className="hover:text-gray-600" data-id="element-69">
              Privacidad
            </a>
            <a href="#" className="hover:text-gray-600" data-id="element-70">
              Contacto
            </a>
          </div>
        </footer>
      </div>
    </section>;
}